export default class AgencyMapAnimation {
    static init() {
        const map = document.getElementById('agency-map');
        const step = map.offsetTop;

        const animMap = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            window.onwheel = event => {
                if (event.deltaY >= 0) {
                    if (scrollPosition >= step) {
                        document.querySelectorAll('.map-circle').forEach((mapCircle) => {
                            mapCircle.classList.add('circle-grow');
                        })
                    }
                }
            }
        };

        window.addEventListener('scroll', animMap);
    }
}
